const ACF_PATTERN = /\[acf\s+field="([A-Za-z0-9_]+)"[^\]]*\]/g;

const replaceACFVariables = (text, variables = {}) => {
  // Always return a string; bail fast if nothing to do.
  if (typeof text !== 'string') return text ?? '';
  if (text.indexOf('[acf') === -1) return text;
  const normalized = text.replace(/&quot;/g, '"');

  return normalized.replace(ACF_PATTERN, (_, fieldPath) => {
    const keys = fieldPath.split('_');
    const first = keys.shift();
    let value = variables?.[first];

    while (value != null && keys.length) {
      const k = keys.shift();
      value = value?.[k];
    }

    return value != null ? String(value) : '';
  });
};

export default replaceACFVariables;
